// Runtime-only generation: even signing in again with the same token is a new session.
let generation = 0;
export const getAuthSessionVersion = () => generation;
export const advanceAuthSession = () => { generation += 1; };
